export default __webpack_public_path__ + "static/media/thumbnail.7137f4a4.png";